/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const shareContentBodyEmailsItemEmailMax = 320;

export const shareContentBodyEmailsItemFirstNameMax = 200;

export const shareContentBodyEmailsItemLastNameMax = 200;

export const shareContentBodyEmailsItemPermissionsMax = 6;

export const shareContentBodyEmailsMax = 50;

export const shareContentBodyGrantsItemPermissionsMax = 6;

export const shareContentBodyGrantsMax = 50;

export const shareContentBodyLineageUuidsMax = 50;

export const shareContentBodyMessageMax = 1000;

export const shareContentBodyRevocationsMax = 50;

export const ShareContentBody = zod.object({
  emails: zod
    .array(
      zod
        .object({
          email: zod.email().max(shareContentBodyEmailsItemEmailMax),
          expiresAt: zod.iso
            .datetime({ offset: true })
            .nullish()
            .describe(
              'When the grant ends (checked by calendar day). Omitted: an existing grant keeps its expiry and a new one has none. null: no expiry.',
            ),
          firstName: zod.string().min(1).max(shareContentBodyEmailsItemFirstNameMax).optional(),
          lastName: zod.string().min(1).max(shareContentBodyEmailsItemLastNameMax).optional(),
          permissions: zod
            .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
            .min(1)
            .max(shareContentBodyEmailsItemPermissionsMax)
            .describe(
              'Stored as the highest rung named: READ < SHARE < COPY < CONTRIBUTE < EDIT < DELETE (Viewer = READ+SHARE+COPY, Contributor = CONTRIBUTE, Editor = EDIT).',
            ),
        })
        .describe(
          'Share with an email address. An existing account is shared with directly; a new address gets an account and the share.',
        ),
    )
    .max(shareContentBodyEmailsMax)
    .optional(),
  grants: zod
    .array(
      zod.object({
        expiresAt: zod.iso
          .datetime({ offset: true })
          .nullish()
          .describe(
            'When the grant ends (checked by calendar day). Omitted: an existing grant keeps its expiry and a new one has none. null: no expiry.',
          ),
        permissions: zod
          .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
          .min(1)
          .max(shareContentBodyGrantsItemPermissionsMax)
          .describe(
            'Stored as the highest rung named: READ < SHARE < COPY < CONTRIBUTE < EDIT < DELETE (Viewer = READ+SHARE+COPY, Contributor = CONTRIBUTE, Editor = EDIT). PUBLIC allows at most Contributor: EDIT or DELETE for everyone is a 400 PUBLIC_PERMISSION_CEILING.',
          ),
        principalType: zod
          .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
          .describe(
            'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
          ),
        principalUuid: zod.uuid().optional().describe('The user or group; omitted for PUBLIC.'),
      }),
    )
    .max(shareContentBodyGrantsMax)
    .optional(),
  idempotencyKey: zod
    .uuid()
    .describe(
      'Caller-generated, required. The same key and the same command replay the stored acknowledgement without sharing again; the same key with a different command is a 409.',
    ),
  includeDescendants: zod
    .boolean()
    .optional()
    .describe(
      'Apply every grant and revocation to everything each lineage CONTAINS as well (default false).',
    ),
  lineageUuids: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .min(1)
    .max(shareContentBodyLineageUuidsMax)
    .describe('What to share: each lineage’s current head.'),
  message: zod
    .string()
    .max(shareContentBodyMessageMax)
    .optional()
    .describe('Included in the notification new recipients receive.'),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  revocations: zod
    .array(
      zod.object({
        principalType: zod
          .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
          .describe(
            'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
          ),
        principalUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      }),
    )
    .max(shareContentBodyRevocationsMax)
    .optional(),
});

export type ShareContentBody = zod.input<typeof ShareContentBody>;
export type ShareContentBodyOutput = zod.output<typeof ShareContentBody>;
